import { Button, Divider, Text, Modal } from '$components'
import { FilterIcon, ChevronLeftIcon } from '$components'
import { Filter } from './types'
import { Fragment, useState } from 'react'
import { useFilters } from './hooks/use-filters'
import { Options } from './options/options'

export type MobileFiltersProps = {
  filters: Filter[]
}

export function MobileFilters({ filters }: MobileFiltersProps) {
  const { isFiltersSet, clearFilters, getFilter } = useFilters()
  const [isMobileModalOpen, setMobileModalOpen] = useState(false)
  const [currentMobileView, setCurrentMobileView] = useState<'list' | 'filter'>('list')
  const [selectedMobileFilter, setSelectedMobileFilter] = useState<Filter | null>(null)

  const handleMobileFilterSelect = (filter: Filter) => {
    setSelectedMobileFilter(filter)
    setCurrentMobileView('filter')
  }

  const handleMobileBack = () => {
    setCurrentMobileView('list')
    setSelectedMobileFilter(null)
  }

  const handleMobileClose = () => {
    setMobileModalOpen(false)
    setCurrentMobileView('list')
    setSelectedMobileFilter(null)
  }

  return (
    <Fragment>
      <Button
        type="button"
        variant="secondary"
        icon={FilterIcon}
        onClick={() => setMobileModalOpen(true)}
        className="relative"
      >
        {isFiltersSet() && (
          <span className="size-2.5 rounded-full bg-indigo-400 absolute top-0 right-0" />
        )}
      </Button>

      {isMobileModalOpen && (
        <Modal onClose={handleMobileClose}>
          <Modal.Header>
            <div className="flex items-center gap-2">
              {currentMobileView === 'filter' && (
                <button
                  onClick={handleMobileBack}
                  className="p-2 -ml-2 border border-transparent hover:border-gray-100 rounded-xl transition-colors"
                >
                  <ChevronLeftIcon className="size-4 text-gray-700" />
                </button>
              )}

              <Modal.Heading>
                {currentMobileView === 'list' ? 'Filters' : selectedMobileFilter?.label}
              </Modal.Heading>
            </div>
          </Modal.Header>

          <Modal.Content>
            {currentMobileView === 'list'
              ? (
                <Fragment>
                  {filters.map((filter, key) => {
                    const isActive = !!getFilter(filter)

                    return (
                      <button
                        key={key}
                        className="w-full p-4 focus:outline-none hover:bg-gray-50/50 flex items-center gap-3 cursor-pointer text-left rounded-2xl md:hover:rounded-none"
                        onClick={() => handleMobileFilterSelect(filter)}
                      >
                        {filter.icon && (
                          <div className="flex-shrink-0">
                            <filter.icon className="size-5 text-gray-500" />
                          </div>
                        )}

                        <Text
                          type="s"
                          className="flex-1"
                        >
                          {filter.label}
                        </Text>

                        {isActive && (
                          <div className="size-2.5 rounded-full bg-indigo-400" />
                        )}
                      </button>
                    )
                  })}

                  {isFiltersSet() && (
                    <Fragment>
                      <div className="m-4">
                        <Divider />
                      </div>

                      <button
                        className="w-full p-4 focus:outline-none hover:bg-gray-50/50 cursor-pointer text-left rounded-2xl md:hover:rounded-none"
                        onClick={() => {
                          clearFilters()
                          handleMobileClose()
                        }}
                      >
                        <Text type="s">
                          Clear filters
                        </Text>
                      </button>
                    </Fragment>
                  )}
                </Fragment>
              )
              : (
                selectedMobileFilter && (
                  <Options filters={[selectedMobileFilter]} />
                )
              )}
          </Modal.Content>
        </Modal>
      )}
    </Fragment>
  )
}
